import React from 'react';
import { chakra } from '@chakra-ui/react';

type Props = {
  size?: number;
  fill?: string;
};

export const XIcon = ({ size = 8, fill = '#ECECEC' }: Props) => (
  <chakra.svg
    xmlns="http://www.w3.org/2000/svg" 
    width={size}
    height={size}
    viewBox="0 0 32 32" 
    fill="none"
  >
    <path 
      d="M17.6174 14.9999L23.0773 8.44446H21.7834L17.0426 14.1363L13.2561 8.44446H8.88867L14.6147 17.0517L8.88867 23.9259H10.1826L15.1892 17.9151L19.1879 23.9259H23.5553L17.617 14.9999H17.6174ZM15.8452 17.1274L15.2649 16.2703L10.6488 9.45051H12.6363L16.3614 14.9544L16.9415 15.8115L21.784 22.9656H19.7967L15.8452 17.1278V17.1274Z" 
      fill={fill}
    />
  </chakra.svg>
);
